import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import camelcaseKeys from 'camelcase-keys'

import Composition from '@src/components/composition/composition'
import { Loader } from '@src/components/loading-screen/loader/loader'
import { API } from '@src/lib/api_path'
import { Spacer } from '@src/elements/spacer/spacer'
import { track } from '@src/util/functions'
import { MemberProfile } from '@src/data/member-profile'
import { ReadonlyHealthGoals } from '@src/routes/member-platform/components/status/health-goals'
import { StatusOverview } from '@src/routes/members/components/status/status-overview'
import { ReadonlyFavoriteActivities } from '@src/routes/member-platform/components/status/favorite-activities'
import { TrainingFrequency } from '@src/routes/members/components/status/training-frequency'
import { ReadonlyDetailsAndTargets } from '@src/routes/member-platform/components/status/details-targets'
import { TrainingStatusComponent } from '@src/routes/members/status'
import ApiClient from '@src/lib/api_client'

import '../../../members/status.sass'
import PortraitComposition from '@src/components/composition/portrait'

type ProfileResponse = { profile: MemberProfile }

@Component({
  computed: {
    member () {
      return this.$store.state.memberProfile
    }
  }
})
export class ReadonlyStatus extends TrainingStatusComponent {

  protected member: MemberProfile

  private windowWidth: number = window.innerWidth

  constructor () {
    /* istanbul ignore next: the undecorated base class constructor returns the instance, the compiled '|| this' fallback never runs */
    super()
    track('/members/status')
  }

  updateWindowSize () {
    this.windowWidth = window.innerWidth
  }

  mounted () {
    window.addEventListener('resize', this.updateWindowSize)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.updateWindowSize)
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.STATUS')}`
  }

  render (h: CreateElement) {
    if (this.loading) {
      return <Loader />
    }

    return <div class='member-status-wrapper scroll-content'>
      <div>
        <ReadonlyHealthGoals />
        <Spacer />
        <StatusOverview member={this.member}/>
        <Spacer />
        <Composition progress={this.progress} bodyCircleDiameter={290}
                     muscleCircleDiameter={this.windowWidth > 800 ? 80 : 85}
                     movementCircleDiameter={this.windowWidth > 800 ? 80 : 85} isFilterEnabled={false}
                     title='PAGE.MEMBERS.STATUS.CURRENT_WORKOUT_OVERVIEW' showLegend={true} showAssistant={false} />

        <PortraitComposition progress={this.progress} bodyCircleDiameter={275}
                             muscleCircleDiameter={61}
                             movementCircleDiameter={this.windowWidth > 600 ? 106 : 80} isFilterEnabled={false}
                             title='PAGE.MEMBERS.STATUS.CURRENT_WORKOUT_OVERVIEW' showLegend={true} />
        <Spacer />
        <TrainingFrequency member={this.member} />
        <ReadonlyDetailsAndTargets member={this.member} />
        <Spacer />
        <ReadonlyFavoriteActivities member={this.member} />
      </div>
    </div>
  }

  beforeMount () {
    return this.loadUserProfile()
  }

  private async loadUserProfile () {
    return new ApiClient().get<ProfileResponse>(API.MEMBERS_API.PROFILE)
      .then((response: ProfileResponse) => this.$store.dispatch('setProfile', new MemberProfile(camelcaseKeys(response.profile, { deep: true }))))
      .catch((error) => console.log('cannot get training status', error))
      .finally(async () => this.loadTrainingStatus())
  }
}
